const Errors = (() => {
  const name = 'Unknown Error'
  const message = 'An unknown Error occured'
  const stack = ''
  const line = ''

  const _create = (err = {}) => {
    const e = new Error()
    err = err === null ? {} : err
    e.name = err.name || name
    e.message = err.message || message
    e.response = err.response || {}
    e.stack = err.stack || stack
    e.line = err.line || line
    return e
  }

  return {
    create: _create
  }
})()

export default Errors
